// extracted by mini-css-extract-plugin
export default {"refreshStyle":"DeviceCard_refreshStyle__50EmU","spinRefresh":"DeviceCard_spinRefresh__BqJLx","refreshStyleLoading":"DeviceCard_refreshStyleLoading__Mh3jR"};